<template>
  <div class="app-dashboard">
    <TagEditModal />
    <TagAddModal />
    <TagDeleteModal />
    <DropAddModal />
    <DropEditModal />
    <div
      class="add-pin-btn"
      :class="'c-' + selectedTag.color.name"
      @click="addPinModal"
    ></div>

    <header>
      <div class="logo-wrap d-logo">
        <div class="logo">
          <div class="dots">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <img class="title" src="./../../assets/images/logo.svg" alt="logo" />
        </div>
      </div>
      <form class="search-form">
        <input type="text" placeholder="search" />
        <button class="search-btn">
          <img src="./../../assets/images/search.svg" alt="" />
        </button>
      </form>
      <div class="account">
        <div class="user-avatar">
          <div class="img"></div>
          <div class="menu">
            <div class="item">Account Settings</div>
            <div class="item">Sign Out</div>
          </div>
        </div>
      </div>
    </header>
    <section class="main-content">
      <nav>
        <div class="tags">
          <div ref="tags" class="tags-wrap">
            <div
              v-for="item in allTags"
              :key="item.id"
              :class="[
                { sortable: item.id != 1 },
                { selected: item.id == selectedTagId },
                'c-' + item.color.name,
              ]"
              class="tag"
              :data-color="item.color.color"
              :title="item.name.length > 13 ? item.name : ''"
              @click="selectTag(item.id)"
            >
              {{ item.name }}
            </div>
            <div class="add-tag-btn" @click="addTagModal"></div>
          </div>
        </div>
        <div class="filters">
          <Dropdown>
            <div class="dropdown-group">
              <div class="item">
                <div class="icon">
                  Aa
                </div>
                <div class="title">
                  Sort by name
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M453.332 512H58.668C26.305 512 0 485.695 0 453.332v-352c0-32.363 26.305-58.664 58.668-58.664h394.664c32.363 0 58.668 26.3 58.668 58.664v352C512 485.695 485.695 512 453.332 512zM58.668 74.668C43.968 74.668 32 86.633 32 101.332v352C32 468.032 43.969 480 58.668 480h394.664c14.7 0 26.668-11.969 26.668-26.668v-352c0-14.7-11.969-26.664-26.668-26.664zm0 0"/><path d="M496 202.668H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h480c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0M122.668 128c-8.832 0-16-7.168-16-16V16c0-8.832 7.168-16 16-16s16 7.168 16 16v96c0 8.832-7.168 16-16 16zm0 0M389.332 128c-8.832 0-16-7.168-16-16V16c0-8.832 7.168-16 16-16s16 7.168 16 16v96c0 8.832-7.168 16-16 16zm0 0"/></svg>
                </div>
                <div class="title">
                  Sort by date
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <svg height="512" viewBox="0 0 475.3 475.3" width="512" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M396.782 475.297c-2.132 0-4.279-.451-6.281-1.395L237.65 402.418 84.798 473.901c-5.439 2.515-11.879 1.541-16.274-2.485a14.877 14.877 0 01-3.989-16.003l58.251-163.475L4.355 173.26a14.89 14.89 0 01-3.22-16.221c2.292-5.567 7.717-8.507 13.722-8.507h159.277L223.667 8.899c4.206-11.861 23.759-11.861 27.965 0l49.534 139.634h159.277c6.005 0 11.43 2.94 13.722 8.507a14.89 14.89 0 01-3.22 16.221L352.513 291.938l58.251 163.475a14.875 14.875 0 01-3.989 16.003 14.814 14.814 0 01-9.993 3.881zM237.65 371.11c2.147 0 4.293.465 6.281 1.395l126.902 59.346-49.447-138.78a14.896 14.896 0 013.481-15.523l99.72-99.928H290.694a14.835 14.835 0 01-13.983-9.884L237.65 58.158l-39.061 109.579a14.834 14.834 0 01-13.983 9.884H50.713l99.72 99.928a14.896 14.896 0 013.481 15.523l-49.447 138.78 126.902-59.346a14.809 14.809 0 016.281-1.396z"/></svg>
                </div>
                <div class="title">
                  Most used
                </div>
              </div>
            </div>
            <div class="dropdown-group">
              <div class="item">
                <div class="icon">
                  <svg height="512pt" viewBox="0 -36 512 511" width="512pt" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M231.898 198.617c28.204 0 51.153-22.945 51.153-51.148 0-28.207-22.95-51.153-51.153-51.153s-51.148 22.946-51.148 51.153c0 28.203 22.945 51.148 51.148 51.148zm0-72.3c11.665 0 21.153 9.488 21.153 21.152 0 11.66-9.488 21.148-21.153 21.148-11.66 0-21.148-9.488-21.148-21.148 0-11.664 9.488-21.153 21.148-21.153zm0 0"/><path d="M493.305.5H18.695C8.387.5 0 8.887 0 19.195v401.727c0 10.308 8.387 18.695 18.695 18.695h474.61c10.308 0 18.695-8.387 18.695-18.695V19.195C512 8.887 503.613.5 493.305.5zM482 30.5v237.406l-94.352-94.355c-6.152-6.14-16.156-6.137-22.304.012l-133.442 133.44-85.238-85.233a15.674 15.674 0 00-11.164-4.63c-4.215 0-8.176 1.641-11.156 4.622L30 316.105V30.5zM30 409.617v-51.086l105.5-105.5 85.234 85.235a15.694 15.694 0 0011.168 4.632c4.211 0 8.176-1.644 11.153-4.625L376.5 204.828l105.504 105.504v99.285zm0 0"/></svg>
                </div>
                <div class="title">
                  Pictures
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M437.019 74.98C388.667 26.628 324.38 0 256 0 187.619 0 123.332 26.629 74.98 74.98 26.629 123.332 0 187.62 0 256s26.629 132.668 74.98 181.02C123.332 485.371 187.619 512 256 512c68.38 0 132.667-26.628 181.019-74.98C485.371 388.667 512 324.38 512 256s-26.629-132.667-74.981-181.02zM256 482C131.383 482 30 380.617 30 256S131.383 30 256 30s226 101.383 226 226-101.383 226-226 226z"/><path d="M128.031 186.954c-7.655-3.161-16.427.479-19.592 8.135C100.451 214.422 96.4 234.915 96.4 256v.161c0 8.284 6.716 15 15 15s15-6.716 15-15V256c0-17.134 3.285-33.773 9.766-49.454 3.163-7.656-.479-16.428-8.135-19.592zM214.298 116.688c-3.186-7.649-11.967-11.264-19.614-8.081-19.398 8.078-36.79 19.75-51.691 34.691-5.85 5.866-5.837 15.363.029 21.213a14.949 14.949 0 0010.592 4.38c3.846 0 7.691-1.47 10.621-4.408 12.108-12.142 26.233-21.624 41.982-28.182 7.647-3.185 11.266-11.966 8.081-19.613zM403.359 194.604c-8.09-19.395-19.772-36.78-34.72-51.672-5.869-5.847-15.366-5.831-21.214.04-5.847 5.869-5.828 15.366.04 21.213 12.149 12.101 21.638 26.221 28.207 41.967 2.401 5.759 7.978 9.23 13.85 9.23a14.95 14.95 0 005.768-1.16c7.645-3.189 11.259-11.973 8.069-19.618zM316.831 108.405C297.519 100.439 277.053 96.4 256 96.4h-.24c-8.284 0-15 6.716-15 15s6.716 15 15 15h.24c17.107 0 33.725 3.276 49.389 9.739a14.958 14.958 0 005.715 1.137c5.894 0 11.485-3.497 13.872-9.284 3.159-7.658-.487-16.427-8.145-19.587zM164.433 347.714c-12.134-12.114-21.608-26.245-28.158-41.998-3.181-7.649-11.958-11.272-19.609-8.092-7.649 3.181-11.272 11.96-8.092 19.609 8.068 19.404 19.73 36.802 34.662 51.711a14.954 14.954 0 0010.599 4.385c3.843 0 7.685-1.468 10.615-4.402 5.853-5.862 5.846-15.36-.017-21.213zM368.875 347.613c-5.859-5.858-15.354-5.856-21.212.004-12.122 12.128-26.258 21.594-42.015 28.136-7.65 3.176-11.278 11.954-8.102 19.605 2.396 5.771 7.978 9.253 13.859 9.253 1.916 0 3.865-.37 5.746-1.15 19.407-8.058 36.812-19.71 51.729-34.635 5.857-5.859 5.854-15.357-.005-21.213zM415.598 255.68c.001-8.284-6.715-15-14.999-15s-15 6.716-15 15l.001.32c0 17.182-3.304 33.865-9.82 49.586-3.173 7.653.46 16.428 8.113 19.601a14.96 14.96 0 005.737 1.147c5.885 0 11.469-3.485 13.862-9.26 8.034-19.382 12.107-39.93 12.107-61.074l-.001-.137v-.183zM256 385.6c-17.158 0-33.818-3.295-49.52-9.793-7.657-3.167-16.429.469-19.597 8.124-3.168 7.655.47 16.428 8.124 19.596C214.365 411.538 234.886 415.6 256 415.6h.08c8.284 0 14.96-6.716 14.96-15 0-8.285-6.756-15-15.04-15z"/></svg>
                </div>
                <div class="title">
                  GIFs
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.997 511.997" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M212.26 390.24l-60.331 60.331c-25.012 25.012-65.517 25.012-90.508.005-24.996-24.996-24.996-65.505-.005-90.496l120.683-120.683c24.991-24.992 65.5-24.992 90.491 0 8.331 8.331 21.839 8.331 30.17 0 8.331-8.331 8.331-21.839 0-30.17-41.654-41.654-109.177-41.654-150.831 0L31.247 329.909c-41.654 41.654-41.654 109.177 0 150.831 41.649 41.676 109.177 41.676 150.853 0l60.331-60.331c8.331-8.331 8.331-21.839 0-30.17s-21.84-8.33-30.171.001z"/><path d="M480.751 31.24c-41.654-41.654-109.199-41.654-150.853 0l-72.384 72.384c-8.331 8.331-8.331 21.839 0 30.17 8.331 8.331 21.839 8.331 30.17 0l72.384-72.384c24.991-24.992 65.521-24.992 90.513 0 24.991 24.991 24.991 65.5 0 90.491L317.845 284.638c-24.992 24.992-65.5 24.992-90.491 0-8.331-8.331-21.839-8.331-30.17 0s-8.331 21.839 0 30.17c41.654 41.654 109.177 41.654 150.831 0l132.736-132.736c41.654-41.654 41.654-109.178 0-150.832z"/></svg>
                </div>
                <div class="title">
                  Links
                </div>
              </div>
              <div class="item">
                <div class="icon">
                  <svg viewBox="0 -62 512.002 512" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M334.809 170.992l-113.114-61.89c-6.504-3.559-14.191-3.426-20.566.351-6.379 3.781-10.184 10.461-10.184 17.875v122.719c0 7.379 3.782 14.047 10.118 17.832 3.308 1.976 6.976 2.969 10.652 2.969a20.74 20.74 0 009.848-2.504L334.68 207.52a20.772 20.772 0 0010.937-18.223 20.763 20.763 0 00-10.808-18.305zm-113.86 63.617v-91.718l84.54 46.257zm0 0"/><path d="M508.234 91.527l-.023-.234c-.434-4.121-4.75-40.777-22.57-59.422C465.043 9.941 441.69 7.277 430.46 6a135.45 135.45 0 01-2.543-.305l-.895-.093C359.336.68 257.113.008 256.09.004L256 0l-.09.004C254.887.008 152.664.68 84.367 5.602l-.902.093c-.727.098-1.528.188-2.399.29-11.101 1.28-34.203 3.949-54.859 26.671C9.234 51.102 4.328 86.973 3.824 91.004l-.058.523C3.613 93.242 0 134.067 0 175.051v38.312c0 40.985 3.613 81.809 3.766 83.528l.027.257c.434 4.055 4.746 40.04 22.484 58.692 19.368 21.195 43.856 24 57.028 25.508 2.082.238 3.875.441 5.097.656l1.184.164c39.082 3.719 161.617 5.55 166.812 5.625l.157.004.156-.004c1.023-.004 103.242-.676 170.93-5.598l.894-.093c.856-.114 1.817-.215 2.871-.325 11.04-1.172 34.016-3.605 54.387-26.02 16.973-18.448 21.883-54.32 22.383-58.347l.058-.523c.153-1.719 3.77-42.54 3.77-83.524v-38.312c-.004-40.985-3.617-81.805-3.77-83.524zm-26.238 121.836c0 37.934-3.312 77-3.625 80.586-1.273 9.88-6.45 32.574-14.719 41.563-12.75 14.027-25.847 15.418-35.41 16.43a164.16 164.16 0 00-3.195.359c-65.469 4.734-163.832 5.46-168.363 5.488-5.082-.074-125.825-1.922-163.715-5.441-1.942-.317-4.04-.559-6.25-.809-11.215-1.285-26.567-3.043-38.371-16.027l-.278-.297c-8.125-8.465-13.152-29.688-14.43-41.149-.238-2.71-3.636-42.238-3.636-80.703v-38.312c0-37.89 3.305-76.914 3.625-80.574 1.52-11.637 6.793-32.957 14.719-41.575 13.14-14.453 26.996-16.054 36.16-17.113.875-.102 1.691-.195 2.445-.293 66.422-4.758 165.492-5.465 169.047-5.492 3.555.023 102.59.734 168.422 5.492.808.102 1.691.203 2.64.313 9.426 1.074 23.672 2.699 36.747 16.644l.12.129c8.126 8.465 13.153 30.059 14.43 41.75.227 2.559 3.637 42.172 3.637 80.719zm0 0"/></svg>
                </div>
                <div class="title">
                  Videos
                </div>
              </div>
            </div>
            <div v-if="selectedTagId != 1" class="dropdown-group">
              <div class="item" @click="editTagModal">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:style="'width: 12px'" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M481.996 30.006C462.647 10.656 436.922 0 409.559 0s-53.089 10.656-72.438 30.005L50.826 316.301a20 20 0 00-5.125 8.779L.733 486.637a20 20 0 0024.732 24.601l161.557-45.891a20 20 0 008.699-33.359L93.869 329.827 331.184 92.511l88.258 88.258-181.674 181.179c-7.821 7.8-7.838 20.463-.038 28.284 7.799 7.822 20.464 7.838 28.284.039l215.98-215.392C501.344 155.53 512 129.805 512 102.442s-10.656-53.088-30.004-72.436zM143.395 436.158L48.827 463.02l26.485-95.152 68.083 68.29zM453.73 146.575l-5.965 5.949-88.296-88.297 5.938-5.938C377.2 46.495 392.88 40 409.559 40c16.679 0 32.358 6.495 44.152 18.29C465.505 70.083 472 85.763 472 102.442c0 16.679-6.495 32.359-18.27 44.133z"/></svg>
                </div>
                <div class="title">
                  Edit tag
                </div>
              </div>
              <div class="item" @click="deleteTagModal">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.001 512.001" v-bind:style="'width: 10px'" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M505.922 476.567L285.355 256 505.92 35.435c8.106-8.105 8.106-21.248 0-29.354-8.105-8.106-21.248-8.106-29.354 0L256.001 226.646 35.434 6.081c-8.105-8.106-21.248-8.106-29.354 0-8.106 8.105-8.106 21.248 0 29.354L226.646 256 6.08 476.567c-8.106 8.106-8.106 21.248 0 29.354 8.105 8.105 21.248 8.106 29.354 0l220.567-220.567 220.567 220.567c8.105 8.105 21.248 8.106 29.354 0s8.106-21.248 0-29.354z"/></svg>
                </div>
                <div class="title">
                  Delete tag
                </div>
              </div>
            </div>
          </Dropdown>
        </div>
      </nav>
      <DropsView />
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Sortable from 'sortablejs';

import TagEditModal from 'app/components/modals/TagEditModal.vue';
import TagAddModal from 'app/components/modals/TagAddModal.vue';
import TagDeleteModal from 'app/components/modals/TagDeleteModal.vue';
import DropAddModal from 'app/components/modals/DropAddModal.vue';
import DropEditModal from 'app/components/modals/DropEditModal.vue';
import Dropdown from 'app/components/common/Dropdown.vue';
import DropsView from 'app/components/dashboard/DropsView.vue';
import { ModalEvents } from '../../utils/events';

export default {
  name: 'Dashboard',
  components: {
    TagEditModal,
    TagAddModal,
    TagDeleteModal,
    DropAddModal,
    DropEditModal,
    Dropdown,
    DropsView,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      allTags: 'tag/allTags',
      selectedTag: 'tag/selectedTag',
      selectedTagId: 'tag/selectedTagId',
    }),
  },

  mounted() {
    Sortable.create(this.$refs.tags, {
      sort: true,
      forceFallback: true,
      draggable: '.sortable',
      ghostClass: 'sortable-ghost-tag',
    });
  },
  methods: {
    selectTag(tag) {
      this.$store.dispatch('tag/selectTag', tag);
    },
    addTagModal() {
      ModalEvents.emit('addTag:open');
    },
    editTagModal() {
      ModalEvents.emit('editTag:open');
    },
    deleteTagModal() {
      ModalEvents.emit('deleteTag:open', this.selectedTag.id);
    },
    addPinModal() {
      ModalEvents.emit('addDrop:open', this.selectedTag.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/mixins.scss';
@import 'styles/colors.scss';
@import 'styles/fonts/playfair.scss';
.app-dashboard {
  $padding: 28px;
  $container-width: 1150px;
  padding-bottom: 30px;

  .add-pin-btn {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozMjZmOWNkZC02MjdkLTQ1ZmUtYTY2Ny01ZWYyMzE4NzFkMTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDQ1NEM2MEY0MjlGMTFFQTlBMTNDNUE3QjJBNDdEMEMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDQ1NEM2MEU0MjlGMTFFQTlBMTNDNUE3QjJBNDdEMEMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5M2ZhM2JhMy1hZjUwLTRjY2ItODQ3NS03OTI5YWZkMTkwYjkiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDplMDg2OTYwMS04MWQ1LTExN2QtYmFlZS1hMmY5NGI0ZGZkYWIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5dPQEPAAAAP0lEQVR42mL8//8/A4kApoGRFE1MDHQCoxaNWjRq0ahFmIAFqewit8wbfD5iJNMno6X3qEWjFo1aNFQsAggwAHRbBzTM9nVZAAAAAElFTkSuQmCC);
    background-color: #fa8072;
    background-repeat: no-repeat;
    border: 1px solid darken(#fa8072, 5%);
    box-shadow: 0px 0px 15px 0px rgba(250, 128, 114, 0.812);
    background-position: center;
    background-size: 20px;
    transition: 0.2s ease;
    position: fixed;
    right: 38px;
    bottom: 38px;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    flex-shrink: 0;
    align-self: flex-start;
    margin-top: 17px;
    margin-left: 10px;
    cursor: pointer;
    @include class-colors-switch(true, true);

    &:hover {
      box-shadow: none;
    }
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 74px;
    flex-shrink: 0;
    border-bottom: 1px solid #e5e6eb;
    padding: 0 $padding;

    form {
      display: flex;
      width: 100%;
      height: 44px;
      max-width: 700px;
      input {
        // padding: $test;
        @include placeholder(
          (
            'color': #b4b3b3,
            'font-style': italic,
          )
        );
        border: none;

        background: #f9f9f9;
        font-size: 14px;
        padding: 0 20px;
        flex-grow: 1;
        border-radius: 5px 0 0 5px;
      }

      button {
        flex-shrink: 0;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 70px;
        background: #f3f3f3;
        border-radius: 0 5px 5px 0;
        img {
          width: 18px;
          height: auto;
        }
      }
    }

    .account {
      flex: 1 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .user-avatar {
        height: 26px;
        width: 26px;
        position: relative;
        padding: 14px;
        margin-right: -14px;
        .img{
          border-radius: 50%;
          height: 100%;
          width: 100%;
          background: rgb(151, 111, 111);
        }

        .menu{
          position: absolute;
          opacity: 0;
          visibility: hidden;
          padding: 10px 0;
          background: white;
          border-radius: 4px;
          box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
          top: 50px;
          right: 0px;
          .item{
            padding: 6px 18px;
            font-size: 14px;
            cursor: pointer;
            color: #3a3a3a;
            text-align: right;
            white-space: nowrap;
            &:hover{
              background: #f6f6f6;
            }
          }
        }

        &:hover{
          .menu {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }
  }

  .main-content {
    max-width: $container-width;
    width: 100%;
    margin: 0 auto;

    nav {
      padding: 45px 0;
      min-height: 127px;
      box-sizing: border-box;
      // display: flex; align-items: center; justify-content: space-between;
      display: grid;
      align-items: flex-start;
      grid-template-columns: auto 1fr;
      .tags {
        display: flex;
        align-items: center;

        .tags-wrap {
          max-width: 925px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-top: -12px;
        }

        .tag {
          background: #eaefff;
          border: 1px solid #d6e1ff;
          white-space: nowrap;
          max-width: 120px;

          overflow: hidden;
          text-overflow: ellipsis;
          color: #aac1fe;
          // color: #fff;
          border-radius: 6px;
          font-size: 12px;
          min-width: 40px;
          padding: 8px 30px;
          box-sizing: border-box;
          margin-right: 12px;
          margin-top: 12px;
          cursor: default;
          text-align: center;
          transition: background 0.2s ease, border 0.2s ease, color 0.2s ease;

          &:hover {
            background: #dbe2ff;
            border: 1px solid #c5d3f9;
            // color: white;
          }

          &.selected {
            background: #fd5bf7;
            border: 1px solid #f531ee;
            color: white;
            @include class-colors-switch(true);
          }
        }
      }
      .add-tag-btn {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4BpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozMjZmOWNkZC02MjdkLTQ1ZmUtYTY2Ny01ZWYyMzE4NzFkMTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDQ1NEM2MEY0MjlGMTFFQTlBMTNDNUE3QjJBNDdEMEMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDQ1NEM2MEU0MjlGMTFFQTlBMTNDNUE3QjJBNDdEMEMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5M2ZhM2JhMy1hZjUwLTRjY2ItODQ3NS03OTI5YWZkMTkwYjkiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDplMDg2OTYwMS04MWQ1LTExN2QtYmFlZS1hMmY5NGI0ZGZkYWIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5dPQEPAAAAP0lEQVR42mL8//8/A4kApoGRFE1MDHQCoxaNWjRq0ahFmIAFqewit8wbfD5iJNMno6X3qEWjFo1aNFQsAggwAHRbBzTM9nVZAAAAAElFTkSuQmCC');
        background-color: #28f6c3;
        background-repeat: no-repeat;
        border: 1px solid #1de0b0;
        background-position: center;
        background-size: 10px;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        flex-shrink: 0;
        align-self: flex-start;
        margin-top: 17px;
        margin-left: 10px;
        cursor: pointer;
      }

      .filters {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .filter-select {
          position: relative;
          margin-left: 20px;
          border-radius: 5px;
          font-size: 14px;
          width: 100px;
          padding: 7px 17px;
          box-sizing: border-box;
          color: #c3d4ff;
          cursor: pointer;

          &:after {
            content: '';
            position: absolute;
            top: calc(50% - 5px);
            right: 15px;
            background: url('./../../assets/images/down-arrow2.svg') no-repeat
              center;
            width: 12px;
            height: 12px;
          }
        }
      }
    }
  }
}

.sortable-ghost {
  background: #f2f2f2;
  border-radius: 8px;
  & * {
    opacity: 0;
  }
}

.sortable-ghost-tag {
  opacity: 0;
}
</style>
